module.exports = __webpack_public_path__ + "static/hero-background-64f5b91700cbe908044f61ddea4dac02.jpg";